import { QIcon_chevron_right } from '@repo/icons/index'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { COLORS } from '../../../../modules/vars'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../pages/[lang]/webview/lessons'

export const LevelDescription = ({ status, level }: { status: string; level: number }) => {
  const { navigate } = useWebviewNavigation()
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const isWebview = useIsWebview()
  const router = useAppRouter()
  const { useLessonsFlow } = useLessonsStack()
  const { push } = useLessonsFlow()
  const { tab, lessonId } = router.query

  const goToLevelPage = () => {
    if (isWebview) {
      push(LESSON_ACTIVITIES_MAP.AILevelDescriptionActivity, { status, level })
    } else if (isMobile) {
      const url = urls.webview.caf.analysis.level(status, level)
      navigate({ url })
    } else {
      const analysisType =
        +tab === 1 ? 'Complexity' : +tab === 2 ? 'Accuracy' : +tab === 3 ? 'Fluency' : 'Pronunciation'
      router.push(urls.student.newPortal.lessons.reviewDetail.asCafLevel(lessonId, tab, level, analysisType))
    }
  }

  if (isMobile) {
    return (
      <div onClick={goToLevelPage} className="flex flex-row items-center justify-end">
        <div className="mr-6 h-16 text-[12px] font-bold text-black">{t(n_caf.level_detail.description)}</div>
        <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY500} />
      </div>
    )
  } else {
    return (
      <div onClick={goToLevelPage} className="flex cursor-pointer items-end justify-end">
        <div className="text-14 mr-6 h-16 font-bold text-gray-500">{t(n_caf.level_detail.description)}</div>
        <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY500} />
      </div>
    )
  }
}
